import {css, html, LitElement} from 'lit';
import {customElement, property, queryAssignedElements, state} from 'lit/decorators.js';
import SlInput from '@shoelace-style/shoelace/dist/components/input/input.js';
import {log} from '../controllers/LogController';

// prevent tree shaking
export {};

@customElement('multi-input')
export class MultiInputElement extends LitElement {
  static override styles = [
    css`
      :host {
        display: flex;
        flex-direction: column;
        gap: 0.7em;
        --sl-spacing-medium: 0.6em;
      }

      ::part(form-control-label) {
        font-size: 105%;
        font-weight: bold;
        font-family: var(--ca-font-headline);
        margin: 0;
        height: 35px;
      }

      sl-button {
        --sl-input-height-medium: 25px;
      }

      sl-button::part(base) {
        border: none;
        background-color: var(--sl-color-neutral-0-3rd);
        color: var(--ca-color-primary);
        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
      }

      sl-button::part(base):hover {
        background-color: var(--ca-color-primary);
        color: var(--sl-color-neutral-0-3rd);
      }

      sl-button::part(base):active {
        background-color: var(--sl-color-neutral-0-2nd);
      }

      sl-button::part(label) {
        margin-top: 2px;
      }

      sl-button span {
        margin-left: 1em;
        font-size: 90%;
      }

      .button-list {
        display: flex;
        gap: 0.3em;
        justify-content: flex-start
      }
    `,
  ];

  @property()
  value: string = '';

  @state()
  private values: string[] = [];

  @queryAssignedElements({selector: 'sl-input'})
  private inputEls!: Array<SlInput>;

  override firstUpdated() {
    this.inputEls.forEach(
      (inputEl) => {
        inputEl.value = this.value;
        inputEl.addEventListener(
          'sl-change',
          (ev: Event) => {
            (ev.target as HTMLInputElement).value += ' ';
            this._handleInput(ev);
          },
        );
        inputEl.addEventListener(
          'keyup',
          (ev: KeyboardEvent) => this._handleInput(ev),
        );
      },
    );
  }

  override render() {
    return html`
      <slot></slot>
      <div class="button-list">
        ${this.values.map(
      (value, index) => html`
            <sl-button size="medium"
                       @click=${(ev: Event) => this._handleButtonClick(ev, index)}
            >
              ${value} <span>✕</span>
            </sl-button>
          `,
    )
    }
      </div>
    `;
  }

  private _handleInput(ev: Event) {
    const inputValue = this.inputEls[0].value;
    if (inputValue.endsWith(' ') && inputValue.trim() !== '') {
      this.values.push(inputValue.trim());
      this.inputEls[0].value = '';
      this.requestUpdate();
      this.dispatchEvent(
        new Event('change', {bubbles: true, composed: true}),
      );
    }
    const newVal = (
      this.values.join(' ')
      + ' '
      + this.inputEls[0].value
    ).trimEnd();
    log(this.constructor.name, '_handleInput', this.values, inputValue, newVal);
    this.value = newVal;
  }

  private _handleButtonClick(ev: Event, index: number) {
    const inputValue = this.inputEls[0].value;
    this.values.splice(index, 1);
    const newVal = (
      this.values.join(' ')
      + ' '
      + inputValue
    ).trimEnd();
    log(this.constructor.name, '_handleButtonClick', this.values, inputValue, newVal);
    this.value = newVal;

    this.dispatchEvent(
      new Event('change', {bubbles: true, composed: true}),
    );
  }
}
